import ExcelJS from 'exceljs';
import moment from 'moment';

const WelcomeBackMemoExcel = async (reportData: any) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Welcome Back Memo');

    // Set column widths for better readability
    worksheet.columns = [
        { header: 'First Name', width: 20 },
        { header: 'Last Name', width: 20 },
        { header: 'Position', width: 25 },
        { header: 'Date of Hire', width: 15 },
        { header: 'District', width: 30 },
        { header: 'Site', width: 30 },
        { header: 'Schedule', width: 35 },
        { header: 'Street', width: 30 },
        { header: 'City', width: 20 },
        { header: 'State', width: 10 },
        { header: 'Zip Code', width: 12 },
    ];

    const columnCount = worksheet.columns.length;
    const lastColumnLetter = worksheet.getColumn(columnCount).letter;

    // Add title row
    worksheet.mergeCells(`A1:${lastColumnLetter}1`);
    const titleCell = worksheet.getCell('A1');
    titleCell.value = 'Welcome Back Memo';
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { horizontal: 'center' };

    // Add header row for the table
    const headerRow = worksheet.addRow([
        'First Name',
        'Last Name',
        'Position',
        'Date of Hire',
        'District',
        'Site',
        'Schedule',
        'Street',
        'City',
        'State',
        'Zip Code',
    ]);
    headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // Sort the data by Last Name, then First Name
    const sortedData = [...(reportData || [])].sort((a: any, b: any) => {
        const lastNameCompare = (a.LastName || '').localeCompare(b.LastName || '', undefined, { numeric: true });
        if (lastNameCompare !== 0) return lastNameCompare;
        return (a.FirstName || '').localeCompare(b.FirstName || '', undefined, { numeric: true });
    });

    // Add data rows
    sortedData.forEach((item: any) => {
        worksheet.addRow([
            item.FirstName || '',
            item.LastName || '',
            item.Position || '',
            item.DateOfHire ? moment(item.DateOfHire).format('MM/DD/YYYY') : '',
            item.DistrictName || '',
            item.SiteName || '',
            item.Schedule || '',
            item.Street || '',
            item.City || '',
            item.State || '',
            item.ZipCode || '',
        ]);
    });

    // Apply borders to all cells
    worksheet.eachRow((row) => {
        row.eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    });

    // Generate Excel buffer and return it
    const buffer = await workbook.xlsx.writeBuffer();
    return buffer;
};

export default WelcomeBackMemoExcel;
